import { flagFactory } from '../icon';
import Svg from './es.svg';

export default flagFactory(Svg);
